import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  STATUS_SOLICITACAO_LABEL,
  StatusSolicitacaoOrcamento,
} from "interfaces/orcamento";
import { ORCAMENTO_ACCENT } from "./orcamento-solicitacoes.theme";

export type SolicitacoesOrcamentoResumo = Record<
  StatusSolicitacaoOrcamento | "TOTAL",
  number
>;

function StatMini({
  label,
  value,
  accent,
}: {
  label: string;
  value: string | number;
  accent?: boolean;
}) {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid",
        borderColor: accent ? "rgba(249, 96, 48, 0.3)" : "grey.200",
        bgcolor: accent ? "rgba(249, 96, 48, 0.04)" : "background.paper",
        height: "100%",
      }}
    >
      <Typography variant="h4" fontWeight="bold" color={accent ? ORCAMENTO_ACCENT : "text.primary"}>
        {value}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}

type Props = {
  resumo: SolicitacoesOrcamentoResumo;
  exibindo: number;
  isFiltered: boolean;
};

export default function SolicitacoesOrcamentoResumoCards({
  resumo,
  exibindo,
  isFiltered,
}: Props) {
  return (
    <Grid container spacing={2} mb={3}>
      <Grid item xs={6} sm={3}>
        <StatMini
          label={isFiltered ? "Exibindo agora" : "Total de solicitações"}
          value={isFiltered ? exibindo : resumo.TOTAL}
          accent
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <StatMini label={STATUS_SOLICITACAO_LABEL.NOVO} value={resumo.NOVO} />
      </Grid>
      <Grid item xs={6} sm={3}>
        <StatMini label={STATUS_SOLICITACAO_LABEL.EM_ANALISE} value={resumo.EM_ANALISE} />
      </Grid>
      <Grid item xs={6} sm={3}>
        <StatMini
          label={STATUS_SOLICITACAO_LABEL.PROPOSTA_ENVIADA}
          value={resumo.PROPOSTA_ENVIADA}
        />
      </Grid>
    </Grid>
  );
}
